export default __webpack_public_path__ + "static/material_03-4d5c4476977094f64f80a72ad18accb0.png";